/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadScreenerLeadInfoState
 */
export interface LeadScreenerLeadInfoState {
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadInfoState
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadInfoState
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadInfoState
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerLeadInfoState
     */
    country_id?: string;
}

/**
 * Check if a given object implements the LeadScreenerLeadInfoState interface.
 */
export function instanceOfLeadScreenerLeadInfoState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadScreenerLeadInfoStateFromJSON(json: any): LeadScreenerLeadInfoState {
    return LeadScreenerLeadInfoStateFromJSONTyped(json, false);
}

export function LeadScreenerLeadInfoStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadInfoState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'country_id': !exists(json, 'country_id') ? undefined : json['country_id'],
    };
}

export function LeadScreenerLeadInfoStateToJSON(value?: LeadScreenerLeadInfoState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'country_id': value.country_id,
    };
}

